module.exports = __webpack_public_path__ + "img/background-pg.d6fc3021.jpg";